var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_2906)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 0.5C5.59315 0.5 4.25 1.84315 4.25 3.5V17.5C4.25 19.1569 5.59315 20.5 7.25 20.5H13.25C14.9069 20.5 16.25 19.1569 16.25 17.5V3.5C16.25 1.84315 14.9069 0.5 13.25 0.5H7.25ZM7.25 2.5C6.69772 2.5 6.25 2.94772 6.25 3.5V17.5C6.25 18.0523 6.69772 18.5 7.25 18.5H13.25C13.8023 18.5 14.25 18.0523 14.25 17.5V3.5C14.25 2.94772 13.8023 2.5 13.25 2.5H12.75C12.75 3.05228 12.3023 3.5 11.75 3.5H8.75C8.19772 3.5 7.75 3.05228 7.75 2.5H7.25Z",
    fill: "#14213D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_2906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.48a342f5cd5fb2026d0e48dbd217236f.svg";
export { ForwardRef as ReactComponent };